
import { Component, Vue } from 'vue-property-decorator'
import PasswordGuide from '@/components/templates/password/PasswordGuide.vue'

/**
 * パスワード再設定トークン無効ページ
 */
@Component({
  components: {
    PasswordGuide,
  },
})
export default class StudentPasswordResetTimeout extends Vue {
  /**
   * ログイン画面のリンク定義
   *
   * @returns 遷移先URL
   */
  private get linkUrl(): string {
    return '/student/login'
  }
}
